import { YEATIES_CONSENT_MOTION } from "@/features/card/configs/yeatiesConsent.config";
import type { TargetAndTransition, Transition } from "motion/react";

type ConsentMotion = {
  from: TargetAndTransition
  to: TargetAndTransition
  transition: Transition
};

// A reduced-motion user still sees each element arrive, through one short fade instead of a movement.
export const getReducedMotionFallback = (shouldReduceMotion: boolean | null, { from, to, transition }: ConsentMotion) => (
  shouldReduceMotion
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: YEATIES_CONSENT_MOTION.reducedFade }
    : { initial: from, animate: to, transition }
);
